export default function IconMinus({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M24 15H8V17H24V15Z" fill="currentColor" />
        </svg>
    )
}
